<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_xii"></a><strong>II. EASTERN EUROPE. RUSSIA AND THE GOLDEN HORDE</strong></p>
<p class="center1"><img alt="Image" height="700" src="images/f0xii-01.jpg" width="577"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?a42d246a